import React from 'react';
import { Outlet } from 'react-router-dom';

export const StepperLayout = () => {
  return (
    <div className={'flex flex-col gap-4 items-center p-4 pb-8'}>
      <div className={'flex flex-col w-full max-w-[900px]'}>
        <div className={'flex items-center'}>
          <h3 className={'flex-1 !mb-1'}>Informations complémentaires</h3>
        </div>
      </div>

      <div className={'w-full max-w-[900px] py-[56px] px-[102px] bg-white'}>
        <Outlet />
      </div>
    </div>
  );
};
